import React, { useEffect, useState } from 'react'
import axios from 'axios'
import useIsMounted from '../hooks/useIsMounted'
import SmallCloseIcon from '../images/small-close-icon.svg'
import { USERNAME, PASSWORD } from '../constants'
import useDebounce from '../hooks/useDebounce'
import { GET_AIRPORT_SUGGESTIONS } from '../routes'

const borderStyle = { border: '1px solid #7f9db9' }

const AutoSuggestAirport = ({
  id,
  place,
  suggestions,
  setSuggestions,
  name,
  value: propValue,
  asHandler,
  setErrors,
  className,
  inputRef,
  onInputFocus,
  isFocused,
  clearInput,
  setClearInput,
  setLoadingSuggestions
}) => {
  const [inputValue, setInputValue] = useState(isFocused ? '' : propValue)
  const [isLoading, setIsLoading] = useState(false)
  const isMounted = useIsMounted()

  const clearSearch = () => {
    setInputValue('')
    asHandler(id, '')
    setSuggestions([])
  }

  const onChange = event => {
    event.preventDefault()
    const { value } = event.target

    if (!inputValue && value && suggestions.length) setSuggestions([])

    if (!value) {
      clearSearch()
    } else {
      setInputValue(value)
      setErrors({})
    }

    onSuggestionsFetchRequestedDebounced(value)
  }

  const onSuggestionsFetchRequested = value => {
    // const authorizationBasic = window.btoa(USERNAME + ':' + PASSWORD)
    // const config = {
    //   headers: {
    //     Authorization: 'Basic ' + authorizationBasic
    //   }
    // }

    if (value && value.length >= 1) {
      setLoadingSuggestions(true)
      setIsLoading(true)
      setSuggestions([])
      const url = GET_AIRPORT_SUGGESTIONS + value
      axios
        .get(url)
        .then(res => {
          if (isMounted.current) {
            res.data.data.length > 0
              ? setSuggestions(res.data.data)
              : setSuggestions(['No Suggestion'])
            setLoadingSuggestions(false)
            setIsLoading(false)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }

  const onSuggestionsFetchRequestedDebounced = useDebounce(
    onSuggestionsFetchRequested,
    500
  )

  const getInitialSuggestions = () => {
    if (propValue) {
      let valueArray = propValue.trim().split('-')
      const airportCode = valueArray[0].trim()
      const cityName = valueArray[1].split(',')[0].trim()
      const countryName = valueArray[1].split(',')[1].trim()

      return [{ airportCode, cityName, countryName, initial: true }]
    }
    return []
  }

  const handleInputFocus = () => {
    setSuggestions(getInitialSuggestions())
    setInputValue('')
    if (!isFocused) {
      onInputFocus()
    }
  }

  useEffect(() => {
    if (!isFocused) {
      setInputValue(propValue)
      isMounted.current = false
    } else {
      isMounted.current = true
    }
    setLoadingSuggestions(false)
    setIsLoading(false)
  }, [isFocused, propValue])

  useEffect(() => {
    return () => {
      onSuggestionsFetchRequestedDebounced.cancel()
    }
  }, [onSuggestionsFetchRequestedDebounced])

  useEffect(() => {
    if (clearInput && clearInput === id) {
      setInputValue('')
      inputRef.current.focus()
      setClearInput(false)
    }
  }, [clearInput, setClearInput, id, inputRef])

  const inputProps = {
    placeholder: place,
    style: { borderStyle },
    className,
    id: id,
    name: name,
    maxLength: '80',
    autoComplete: 'off',
    value: inputValue,
    onChange,
    onFocus: handleInputFocus,
    ref: inputRef
  }

  return (
    <>
      <input type='text' {...inputProps} />
      {!isLoading && (
        <a id='from_glyphicon' onClick={() => clearSearch(id)}>
          <img
            src={SmallCloseIcon}
            alt='Cross Sign'
            className='deptCrsSign'
            style={{ display: !!inputValue ? 'block' : 'none' }}
          />
        </a>
      )}
    </>
  )
}

export default AutoSuggestAirport
